import geohash from "ngeohash";
import rawGhAdaptive from "@/geohash3-4-adaptive.json?raw";

const ghAdaptive = JSON.parse(rawGhAdaptive);

export function countryCodeFromLatLng(lat, lng) {
  const gh4 = geohash.encode(lat, lng, 4);
  const gh3 = gh4.slice(0, 3);
  const result = ghAdaptive[gh4] ?? ghAdaptive[gh3] ?? null;

  return result;
}